import { useState } from 'react'
import type { CampaignFormFieldErrors, CampaignFormValues } from '@/components/campaigns/CampaignForm'
import type { CampaignFormTouched } from './form-model'
import { validateCampaignForm } from './form-model'

/** Local field/touched/validation state shared by New and Edit — default, dirty, and validation-error states. */
export function useCampaignFormState(initialValues: CampaignFormValues) {
	const [values, setValues] = useState<CampaignFormValues>(initialValues)
	const [touched, setTouched] = useState<CampaignFormTouched>({})
	const [fieldErrors, setFieldErrors] = useState<CampaignFormFieldErrors>({})

	function onFieldChange<K extends keyof CampaignFormValues>(field: K, value: CampaignFormValues[K]) {
		setValues((current) => ({ ...current, [field]: value }))
		setTouched((current) => ({ ...current, [field]: true }))
	}

	function validate(): boolean {
		const errors = validateCampaignForm(values)
		setFieldErrors(errors)
		return Object.keys(errors).length === 0
	}

	return {
		values,
		touched,
		fieldErrors,
		isDirty: Object.values(touched).some(Boolean),
		onFieldChange,
		validate,
	}
}
